function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PortugalFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1779",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1779)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 3H24V21H6V3Z",
      fill: "#EF0000"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H9V21H0V3Z",
      fill: "#2F8D00"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1779",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "3",
      y: "6",
      width: "12",
      height: "12",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.92857 17.8554C5.73321 17.8554 3.14285 15.2339 3.14285 12C3.14285 8.76617 5.73321 6.1446 8.92857 6.1446C12.1239 6.1446 14.7143 8.76617 14.7143 12C14.7143 15.2339 12.1239 17.8554 8.92857 17.8554Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1779)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.57141 6H9.32141V8.0241H8.57141V6Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.57141 16.1205H9.32141V18H8.57141V16.1205Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.23584 12.3028L3.02615 11.7649C5.34004 10.8411 7.08646 10.2454 8.27146 9.97689C10.01 9.58299 11.9204 9.29155 14.0025 9.10236L14.0536 9.67835C11.9953 9.86537 10.1095 10.1531 8.39629 10.5412C7.24658 10.8017 5.52441 11.3892 3.23584 12.3028Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.3556 8.74797L14.1855 9.30004C12.4367 8.74796 11.0121 8.51065 9.91709 8.58415L9.87927 8.0071C11.055 7.92818 12.5453 8.17646 14.3556 8.74797Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.9607 11.8348L14.6375 12.3117C13.746 11.6928 12.6476 11.3819 11.335 11.3819V10.8036C12.758 10.8036 13.9691 11.1464 14.9607 11.8348Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.4765 12.008L14.6243 12.5666C12.7023 13.0872 10.8978 13.3826 9.21073 13.4521C7.51201 13.5222 5.53212 13.2257 3.26935 12.5651L3.42774 12.0095C5.63551 12.654 7.55599 12.9416 9.18747 12.8743C10.8306 12.8066 12.5937 12.518 14.4765 12.008Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.2588 14.7269L13.3555 15.6529C11.639 13.938 10.1278 12.7118 8.83125 11.975C7.51252 11.2257 5.79277 10.4647 3.67468 9.6953L4.10904 8.4706C6.2896 9.26271 8.0726 10.0516 9.46072 10.8404C10.871 11.6418 12.4673 12.9371 14.2588 14.7269Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.09373 15.2515L3.75183 14.7881C3.79958 14.7521 3.88477 14.6919 4.00214 14.6156C4.19594 14.4897 4.41114 14.364 4.64269 14.2466C5.28042 13.9231 5.92012 13.7211 6.53026 13.7025C6.5601 13.7016 6.58981 13.7012 6.6194 13.7012V14.2795C6.59556 14.2795 6.57157 14.2798 6.54742 14.2806C6.03324 14.2962 5.46859 14.4745 4.89874 14.7636C4.68634 14.8713 4.48844 14.9869 4.31083 15.1023C4.24901 15.1425 4.19431 15.1796 4.14743 15.2127C4.12011 15.232 4.10197 15.2453 4.09373 15.2515Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.3591 15.452L4.503 14.8923C6.40809 15.394 7.87681 15.644 8.90182 15.644C9.92301 15.644 11.443 15.3491 13.4518 14.7573L13.6115 15.3125C11.5552 15.9184 9.98856 16.2223 8.90182 16.2223C7.81891 16.2223 6.30711 15.965 4.3591 15.452Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.61682 10.2709L4.52213 9.3469L5.84762 10.6771L4.94231 11.6011L3.61682 10.2709Z",
        fill: "#FFE017"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.127 14.8858L11.8003 13.7774L13.9031 15.0857L13.2297 16.1942L11.127 14.8858Z",
        fill: "#FFE017"
      })]
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.14285 12C3.14285 15.2339 5.73321 17.8554 8.92857 17.8554C12.1239 17.8554 14.7143 15.2339 14.7143 12C14.7143 8.76617 12.1239 6.1446 8.92857 6.1446C5.73321 6.1446 3.14285 8.76617 3.14285 12ZM14 12.0723C14 14.867 11.7614 17.1326 8.99999 17.1326C6.23857 17.1326 4 14.867 4 12.0723C4 9.27765 6.23857 7.0121 8.99999 7.0121C11.7614 7.0121 14 9.27765 14 12.0723Z",
      fill: "#F9E813"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.74252 8.38896V13.0845C6.05162 14.943 7.09297 15.8723 8.86656 15.8723C10.6402 15.8723 11.6815 14.943 11.9906 13.0845V8.38896H5.74252Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.56393 7.5H12.8692V13.0671L12.8622 13.1056C12.461 15.3298 11.0387 16.5 8.71655 16.5C6.39435 16.5 4.97208 15.3298 4.57088 13.1056L4.56393 13.0671V7.5Z",
      fill: "#C51918"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.7857 8.92951H5.4357V10.2795H6.7857V8.92951ZM12.0357 8.92951H10.6857V10.2795H12.0357V8.92951Z",
      fill: "#F9E813"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.4357 11.9295H6.7857V13.2795H5.4357V11.9295ZM10.7604 11.9508H12.1104V13.3008H10.7604V11.9508ZM10.7808 14.137H9.43081V15.487H10.7808V14.137Z",
      fill: "#F9E813"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.48639 14.131H7.83639V15.481H6.48639V14.131Z",
      fill: "#F9E813"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.63916 9.53302H11.094V12.8637C11.094 12.8637 10.7634 14.5837 8.86656 14.5837C6.96974 14.5837 6.63916 12.8637 6.63916 12.8637V9.53302Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.42856 9.90362H9.41881V10.6247C9.41881 10.6247 9.34532 10.9971 8.92368 10.9971C8.50204 10.9971 8.42856 10.6247 8.42856 10.6247V9.90362Z",
      fill: "#013399"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.42856 11.4939H9.41881V12.2151C9.41881 12.2151 9.34532 12.5874 8.92368 12.5874C8.50204 12.5874 8.42856 12.2151 8.42856 12.2151V11.4939Z",
      fill: "#013399"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.71426 11.4939H10.7045V12.2151C10.7045 12.2151 10.631 12.5874 10.2094 12.5874C9.78775 12.5874 9.71426 12.2151 9.71426 12.2151V11.4939Z",
      fill: "#013399"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.14285 11.4939H8.1331V12.2151C8.1331 12.2151 8.05962 12.5874 7.63798 12.5874C7.21634 12.5874 7.14285 12.2151 7.14285 12.2151V11.4939Z",
      fill: "#013399"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.42856 13.0843H9.41881V13.8054C9.41881 13.8054 9.34532 14.1778 8.92368 14.1778C8.50204 14.1778 8.42856 13.8054 8.42856 13.8054V13.0843Z",
      fill: "#013399"
    })]
  })]
}));
//# sourceMappingURL=Portugal.js.map